import { kmmRequest } from './kmm';

export const deleteCustomerFavList = async (favoriteListId: number): Promise<boolean> => {
  const response = await kmmRequest('deleteCustomerFavList', { favoriteList: favoriteListId });

  return JSON.parse(response) as boolean;
};

export default deleteCustomerFavList;
